import { useEffect, useState } from 'react'

// Обратный отсчёт до untilIso (клиентский тик, как useLiveSeconds — но вниз).
// Значение выводится из now-состояния, не из прямого Date.now() в рендере, иначе
// React Compiler заморозит его. У paused-сессии тик не нужен — компонент передаёт
// статический remaining_seconds мимо этого хука (untilIso=null → 0, без интервала).
export function useCountdown(untilIso: string | null | undefined): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!untilIso) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [untilIso])

  if (!untilIso) return 0
  return Math.max(0, Math.round((new Date(untilIso).getTime() - now) / 1000))
}
